import { MentorshipFeedback } from "@/lib/api/mentorships";
import { BarChartBig } from "lucide-react";
import { SectionHeader } from "../section-header";
import { Stats } from "../stats";

interface TeenWellbeingProps {
  current: MentorshipFeedback["teenWellBeing"]["current"];
}

export function TeenWellbeingStats({ current }: TeenWellbeingProps) {
  const stats = [
    {
      label: "PHQ",
      value: current?.phq8Response || current?.phq2Response || "-",
      date: current?.created_at,
      type: current?.phq8Response ? "PHQ-8" : "PHQ-2",
    },
    {
      label: "GAD",
      value: current?.gad8Response || current?.gad2Response || "-",
      date: current?.created_at,
      type: current?.gad8Response ? "GAD-8" : "GAD-2",
    },
    {
      label: "RISK",
      value: current?.riskResponseNew || current?.riskResponse || "-",
      date: current?.created_at,
      type: current?.riskResponseNew ? "CSSRS" : "Risk Response",
    },
  ];

  return (
    <>
      <SectionHeader
        icon={<BarChartBig className="h-6 w-6 text-zinc-700" />}
        title="Teen Wellbeing"
      />
      <Stats stats={stats} />
    </>
  );
}
